export function createSellStore() {
    return {
        namespaced: true,

        state: {
            activeItemTypeTab: null,

            /**
             * Count of all active non-ask-early custom fields in the db.
             *
             * @type {number|null}
             */
            fieldsCount: null,
        },

        mutations: {
            setActiveItemTypeTab(state, value) {
                state.activeItemTypeTab = value;
            },

            setFieldsCount(state, value) {
                state.fieldsCount = value;
            },
        },
    };
}
